import { Action } from "features/Permission/types";

export interface DashboardOption {
  linkTo: string;
  title: string;
  icon: string;
  bgColor: string;
  requiredPermissions?: Action | Action[];
}

export const dashBoardOptions: DashboardOption[] = [
  {
    linkTo: "leads-list",
    title: "All Leads",
    icon: "/assets/leads.svg",
    bgColor: "bg-[#bbd0ce]",
  },
  {
    linkTo: "leads/create-lead",
    title: "Create Lead",
    icon: "/assets/leads.svg",
    bgColor: "bg-[#ebdbcf]",
  },
  {
    linkTo: "applications",
    title: "All Applications",
    icon: "/assets/application-status.svg",
    bgColor: "bg-blue-200",
  },
  {
    linkTo: "login-history",
    title: "Login History",
    icon: "/assets/location-tracker.svg",
    bgColor: "bg-blue-200",
    requiredPermissions: [Action.VIEW_USER_LOGIN_HISTORY],
  },
  {
    linkTo: "tasks",
    title: "Tasks",
    icon: "/assets/performance.svg",
    bgColor: "bg-orange-200",
  }
];
